import { useContext } from "react";
import RootStoreContext from "../contexts/root-store-context";

const useStore = () => useContext(RootStoreContext)

export default useStore